/**
 * Berichten store — sidebar-badge polling (60s).
 *
 * Houdt de open-count bij van de stroom die kantoor moet afhandelen
 * (field_to_office). Lijst- en detail-data wordt in components opgehaald via
 * `lib/berichten.ts`. Vervangt field-messages-store + werkbon-taken-store.
 */

import { create } from 'zustand';
import { fetchBerichtCounts, type BerichtCounts } from '../lib/berichten';

interface BerichtenState {
  counts: BerichtCounts;
  pollingIntervalId: ReturnType<typeof setInterval> | null;

  refresh: () => Promise<void>;
  startPolling: (intervalMs?: number) => void;
  stopPolling: () => void;
}

const EMPTY: BerichtCounts = { open: 0, total: 0 };

export const useBerichtenStore = create<BerichtenState>()((set, get) => ({
  counts: EMPTY,
  pollingIntervalId: null,

  refresh: async () => {
    try {
      // 'inbound' = alles dat kantoor moet oppakken: van uitvoering én van reparateur.
      const counts = await fetchBerichtCounts('inbound');
      set({ counts });
    } catch (error) {
      console.warn('[berichten-store] refresh error:', error);
    }
  },

  startPolling: (intervalMs = 60_000) => {
    const { pollingIntervalId, refresh } = get();
    if (pollingIntervalId) return;
    refresh();
    const id = setInterval(() => refresh(), intervalMs);
    set({ pollingIntervalId: id });
  },

  stopPolling: () => {
    const { pollingIntervalId } = get();
    if (pollingIntervalId) {
      clearInterval(pollingIntervalId);
      set({ pollingIntervalId: null });
    }
  },
}));
